module.exports = __webpack_public_path__ + "img/users.821e5503.svg";